import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

export const PreloadAssets = () => {
  // fallback/err
  useLoader.preload(
    GLTFLoader,
    "/assets/models/utility/henge/fallback/error/error.glb",
  );

  // loader/in-process
  useLoader.preload(
    GLTFLoader,
    "/assets/models/utility/henge/loader/in-process/loading.glb",
  );

  // loader/in-process/empty-file
  useLoader.preload(
    GLTFLoader,
    "/assets/models/utility/henge/loader/in-process/empty-file.glb",
  );

  return <></>;
};
